/**
 * Normaliza el nombre de un país eliminando acentos y caracteres especiales
 * para que "Perú" y "Peru" se traten como el mismo país
 * @param {string} country - Nombre del país
 * @returns {string} - Nombre normalizado
 */
export const normalizeCountry = (country) => {
    if (!country || typeof country !== 'string') return '';
    
    return country
        .normalize('NFD') // Descompone caracteres acentuados
        .replace(/[\u0300-\u036f]/g, '') // Elimina diacríticos (acentos)
        .toLowerCase()
        .trim();
};

/**
 * Compara dos nombres de países ignorando acentos y mayúsculas
 * @param {string} country1 - Primer país
 * @param {string} country2 - Segundo país
 * @returns {boolean} - true si son el mismo país
 */
export const areCountriesEqual = (country1, country2) => {
    return normalizeCountry(country1) === normalizeCountry(country2);
};

/**
 * Agrupa países duplicados (con y sin acentos) en un solo nombre
 * Usa el primer nombre encontrado como representante
 * @param {string[]} countries - Array de nombres de países
 * @returns {string[]} - Array de países únicos
 */
export const deduplicateCountries = (countries) => {
    if (!Array.isArray(countries)) return [];
    
    const seen = new Map(); // Map<normalized, original>
    
    countries.forEach(country => {
        if (!country) return;
        const normalized = normalizeCountry(country);
        if (!seen.has(normalized)) {
            seen.set(normalized, country);
        }
    });
    
    return Array.from(seen.values()).sort();
};

/**
 * Encuentra el nombre original de un país normalizado
 * Útil para mantener consistencia en la visualización
 * @param {string} normalizedCountry - País normalizado
 * @param {string[]} availableCountries - Lista de países disponibles
 * @returns {string|null} - Nombre original del país o null
 */
export const findOriginalCountryName = (normalizedCountry, availableCountries) => {
    if (!normalizedCountry || !Array.isArray(availableCountries)) return null;
    
    const normalized = normalizeCountry(normalizedCountry);
    
    for (const country of availableCountries) {
        if (normalizeCountry(country) === normalized) {
            return country;
        }
    }
    
    return null;
};





